<template>
  <div v-if="show" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <!-- 背景遮罩 -->
      <div 
        v-if="show"
        class="fixed inset-0 transition-opacity"
        @click="closeModal"
      >
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- 模态框内容 -->
      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
        <!-- 标题 -->
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-medium text-gray-900">
            个人资料
          </h3>
          <button
            @click="closeModal"
            class="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon class="h-6 w-6" />
          </button>
        </div>

        <!-- 头像区域 -->
        <div class="mb-6 text-center">
          <div class="mx-auto h-16 w-16 rounded-full bg-gray-300 flex items-center justify-center mb-3">
            <span class="text-xl font-medium text-gray-700">
              {{ getUserInitial() }}
            </span>
          </div>
          <div class="text-sm text-gray-600">
            {{ authStore.user?.email || '' }}
          </div>
          <div v-if="authStore.user?.account_type === 'sub'" class="mt-1 text-xs text-blue-600">
            子账户
          </div>
        </div>

        <!-- 基本信息表单 -->
        <form id="profile-form" @submit.prevent="updateProfile" class="space-y-6 mb-6">
          <!-- 基本信息 -->
          <div>
            <h4 class="text-sm font-medium text-gray-900 mb-3 border-b border-gray-200 pb-2">基本信息</h4>
            <div class="space-y-4">
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    姓名
                  </label>
                  <input
                    v-model="profileForm.first_name"
                    type="text"
                    class="w-full h-10 px-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                    placeholder="请输入姓名"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    用户名 <span class="text-red-500">*</span>
                  </label>
                  <input
                    v-model="profileForm.username"
                    type="text"
                    required
                    class="w-full h-10 px-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                    placeholder="请输入用户名"
                  />
                </div>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  邮箱 <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="profileForm.email"
                  type="email"
                  required
                  class="w-full h-10 px-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                  placeholder="请输入邮箱地址"
                />
              </div>
            </div>
          </div>

          <!-- 联系信息 -->
          <div>
            <h4 class="text-sm font-medium text-gray-900 mb-3 border-b border-gray-200 pb-2">联系信息</h4>
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  手机号码
                </label>
                <input
                  v-model="profileForm.phone"
                  type="tel"
                  class="w-full h-10 px-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                  placeholder="请输入手机号码"
                />
              </div>
            </div>
          </div>

          <!-- 工作信息 -->
          <div>
            <h4 class="text-sm font-medium text-gray-900 mb-3 border-b border-gray-200 pb-2">工作信息</h4>
            <div class="space-y-4">
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    部门
                  </label>
                  <input
                    v-model="profileForm.department"
                    type="text"
                    class="w-full h-10 px-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                    placeholder="请输入部门"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    职位
                  </label>
                  <input
                    v-model="profileForm.position"
                    type="text"
                    class="w-full h-10 px-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
                    placeholder="请输入职位"
                  />
                </div>
              </div>
            </div>
          </div>

        </form>


        <!-- 底部按钮 -->
        <div class="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <button
            @click="closeModal"
            type="button"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-colors"
          >
            关闭
          </button>
          <button 
            type="submit" 
            form="profile-form"
            :disabled="isUpdatingProfile"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center transition-colors"
          >
            <svg v-if="isUpdatingProfile" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isUpdatingProfile ? '保存中...' : '保存资料' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useToast } from 'vue-toastification'
import { XMarkIcon } from '@heroicons/vue/24/outline'

// Props
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['close'])

// Composables
const authStore = useAuthStore()
const toast = useToast()

// State
const isUpdatingProfile = ref(false)

// 个人资料表单
const profileForm = ref({
  first_name: '',
  username: '',
  email: '',
  phone: '',
  department: '',
  position: ''
})

// Watch for modal show/hide
watch(() => props.show, (show) => {
  if (show) {
    resetForm()
    initializeProfileForm()
  }
})

// Methods
const resetForm = () => {
  isUpdatingProfile.value = false
}

const initializeProfileForm = () => {
  if (authStore.user) {
    profileForm.value = {
      first_name: authStore.user.first_name || '',
      username: authStore.user.username || '',
      email: authStore.user.email || '',
      phone: authStore.user.phone || '',
      department: authStore.user.department || '',
      position: authStore.user.position || ''
    }
  }
}

const getUserInitial = () => {
  const user = authStore.user
  if (user?.first_name) return user.first_name.charAt(0).toUpperCase()
  if (user?.last_name) return user.last_name.charAt(0).toUpperCase()
  if (user?.username) return user.username.charAt(0).toUpperCase()
  return 'U'
}

const validateForm = () => {
  // 验证用户名
  if (!profileForm.value.username || profileForm.value.username.trim().length === 0) {
    toast.error('请输入用户名')
    return false
  }
  
  // 验证邮箱格式
  if (!profileForm.value.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(profileForm.value.email)) {
    toast.error('请输入有效的邮箱地址')
    return false
  }
  
  // 验证手机号格式（如果填写了）
  if (profileForm.value.phone && !/^1[3-9]\d{9}$/.test(profileForm.value.phone.replace(/\D/g, ''))) {
    if (profileForm.value.phone.trim()) {
      toast.error('请输入有效的手机号码')
      return false
    }
  }
  
  return true
}

const updateProfile = async () => {
  if (isUpdatingProfile.value) return
  
  // 表单验证
  if (!validateForm()) {
    return
  }
  
  isUpdatingProfile.value = true
  
  try {
    await authStore.updateProfile(profileForm.value)
    // toast提示已在authStore中处理
    // 保存成功后先重置状态，再关闭模态框
    isUpdatingProfile.value = false
    closeModal()
  } catch (error) {
    console.error('更新资料失败:', error)
    toast.error('更新资料失败，请稍后重试')
    isUpdatingProfile.value = false
  }
}

const closeModal = () => {
  if (!isUpdatingProfile.value) {
    emit('close')
  }
}
</script>